import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * tailwind-merge instance extended with the project's custom font-size tokens.
 *
 * Without the extension, tailwind-merge's default config falls back to treating
 * any unrecognized `text-*` class as a text-color utility. That means a custom
 * font-size like `text-body` ends up in the same conflict group as `text-gray-500`,
 * and the later one wins — silently stripping our font-size from the output.
 *
 * Add any new custom font-size classes registered in `podo-tailwind.config.ts`
 * under `theme.fontSize` to the list below.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': ['text-body', 'text-body-regular', 'text-subtitle', 'text-badge'],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
